import config from '../../utils/config.js';

const ORIGIN = config.origin;

export const postLocationData = async (location, currentUser) => {
    try {
        const response = await fetch(`${ORIGIN}/wms/location-utilization/location-check`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${currentUser.userId}${currentUser.userEmail}`,
            },
            body: JSON.stringify({
                location: location,
                authentication: {
                    ...currentUser,
                },
            }),
        });

        if (!response.ok) {
            return {
                error: 'Bad response',
            };
        }

        const data = await response.json();

        return data;
    } catch (err) {
        return {
            error: err,
        };
    }
};

export const postUtilizationRank = async (location, utilizationRank, currentUser) => {
    try {
        const response = await fetch(`${ORIGIN}/wms/location-utilization/save-utilization-rank`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${currentUser.userId}${currentUser.userEmail}`,
            },
            body: JSON.stringify({
                location: location,
                utilizationRank: utilizationRank,
                authentication: {
                    ...currentUser,
                },
            }),
        });

        if (!response.ok) {
            return {
                error: 'Bad response',
            };
        }

        const data = await response.json();

        return data;
    } catch (err) {
        return {
            error: err,
        };
    }
};

export const WMSFetch = async (route, body, currentUser) => {
    const response = await fetch(`${ORIGIN}/${route}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...body,
            authentication: {
                userId: currentUser.authentication.userId,
                userEmail: currentUser.authentication.userEmail,
                userCompany: currentUser.authentication.userCompany || localStorage.getItem('company'),
            },
        }),
    });

    if (!response.ok) {
        throw Error('Bad response from fetch');
    }

    const data = await response.json();
    return data;
};
